<template>
    <div>
        <div v-if="validationMessages">
            <v-alert
            outlined
            type="error"
            icon="mdi-information"
            text
            v-for="(message, index) in messages" :key="index"
            dense
            dismissible
            >
            {{ message }}
            </v-alert>
        </div>
    </div>
</template>

<script>

export default {
    name: 'form-validation-messages',
    props: ['messages'],

    data: () => ({

    }),

    computed: {
        validationMessages() {
            if(this.messages == undefined) {
                return false;
            }

            if(this.messages !== undefined && this.messages.length == 0) {
                return false;
            }

            return true;
            
        }
    },

    created() {

    },

    mounted() {
        //window.console.log("FormValidationMessages.vue");
        //window.console.log(this.messages);

    }
}

</script>

<style scoped>

</style>